import { z } from 'zod'

export const LoyaltyCardNotFullSchema = z.object({
  errorResolutionType: z.literal('LOYALTY_CARD_NOT_FULL'),
})
